<template>
  <div class="UnbundCard" v-if="vanPopupShow">
    <van-popup
      v-model="vanPopupShow"
      closeable
      position="bottom"
      :style="{ height: '55%' }"
    >
      <div class="popupBox">
        <div class="popupHeader">
          <div class="popupHeaderLeft">解除绑定</div>
          <div class="popupHeaderRight" @click="close">
            <van-icon name="cross" class="cross" />
          </div>
        </div>
        <div class="popupContent">
          <div class="popupBankName">
            <div class="popupBankNameLeft">
              {{ bankName || '中国农业银行' }}
            </div>
            <div class="popupBankNameright">
              **** **** **** {{ bindingAcctNo }}
            </div>
          </div>
          <!-- <div class="popupBankNum"></div> -->
          <Form :model="form" :rules="rules" v-model="regular">
            <Input
              label="手机号"
              v-model="form.custMobile"
              :reg="rules.custMobile"
              maxlength="11"
              labelWidth="90px"
              type="tel"
              placeholder="请输入银行预留手机号"
            />
            <message-code
              label="验证码"
              :reg="rules.randomPassword"
              placeholder="请输入验证码"
              v-model="form.randomPassword"
              :params="{
                cust_mobile: form.custMobile,
                biz_scene: '105322',
              }"
            ></message-code>
          </Form>
          <div class="unbundlBox">
            <div class="unbundl" @click="leftNext">
              取消解绑
            </div>
            <div class="confirm">
              <Button
                :loading="loading"
                loadingText="提交中..."
                type="danger"
                text="确认解绑"
                :disabled="!regular"
                class="nextStep"
                :click="nextStep"
              />
            </div>
          </div>
        </div>
      </div>
    </van-popup>
    <self-popup v-model="ShowContent"></self-popup>
  </div>
</template>

<script>
import Input from '@/components/Input.vue';
import Form from '@/components/Form.vue';
import { mapState, mapMutations } from 'vuex';
import MessageCode from '@/components/MessageCode.vue';
import Button from '@/components/Button.vue';
import { rules } from '@/utils';

export default {
  name: 'UnbundCard',
  components: {
    Input,
    Form,
    MessageCode,
    Button,
  },
  data() {
    return {
      vanPopupShow: false,
      banklist: [],
      regular: false,
      loading: false,
      ShowContent: '',
      legalPhone: '',
      form: {
        custMobile: '',
        randomPassword: '',
      },
      rules: {
        custMobile: rules.legalPhone,
        randomPassword: rules.captcha,
      },
    };
  },
  props: {
    value: {
      type: Boolean,
    },
    bindingAcctNo: {
      type: String,
    },
    custMobile: {
      type: String,
    },
    bankName: {
      type: String,
    },
  },
  watch: {
    form: {
      handler(newVal, oldVal) {
        console.log(newVal, oldVal, 'oldVal');
        this.$emit('monitorForm', newVal);
      },
      deep: true,
      immediate: true,
    },
    value: {
      handler(newVal, oldVal) {
        if (oldVal === undefined) {
          this.vanPopupShow = this.value;
        }
        this.vanPopupShow = newVal;
        this.$emit('input', newVal);
      },
      immediate: true,
    },
    custMobile: {
      handler(newVal) {
        this.form.custMobile = newVal;
      },
      immediate: true,
    },
    vanPopupShow: {
      handler(newVal) {
        this.form.randomPassword = '';
        this.$emit('input', newVal);
      },
      immediate: true,
    },
  },
  computed: {
    ...mapState({
      capitalAccount(val) {
        return val.capitalAccount;
      },
    }),
  },
  methods: {
    ...mapMutations('capitalAccount', ['updateState']),

    nextStep() {
      this.loading = true;
      this.regular = false;
      const { custMobile, randomPassword } = this.form;
      const { bindingCardId, orderId } = this.capitalAccount;
      const params = {
        orderId,
        bindingCardId,
        custMobile,
        randomPassword,
      };
      this.$api.CommonForms.getUnbindCard(params)
        .then(async (res) => {
          if (res.success) {
            this.form.randomPassword = '';
            this.$emit('input', false);
            this.$emit('getAccountList');
          } else {
            this.ShowContent = res.returnMessage;
          }
          this.loading = false;
          this.regular = true;
        })
        .catch((e) => {
          this.ShowContent = e;
          this.loading = false;
          this.regular = true;
        });
    },

    leftNext() {
      this.$emit('input', false);
    },

    rightNext() {
      this.$emit('input', false);
    },

    close() {
      this.$emit('input', false);
    },
  },
};
</script>
<style scoped>
.supportBox {
  position: relative;
}
.bankSupport {
  position: absolute;
  right: 16px;
  top: 12px;
  font-family: PingFangSC-Regular;
  font-size: 15px;
  color: #ff6538;
}
.UnbundCard >>> .van-field__label {
  text-align: left;
}
.nextStep {
  width: 100%;
  padding: 0;
}
.UnbundCard >>> .van-button--danger {
  color: #fff;
  background-image: linear-gradient(180deg, #f5514a 2%, #f5683c 99%);
  border: none;
}
.UnbundCard >>> .van-field__body > input {
  width: 174px;
}
.nextStep >>> .van-button--danger {
  display: flex;
  justify-content: center;
}
/* 弹框 */
.popupHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 16px;
}
.popupHeaderLeft {
  font-family: PingFangSC-Medium;
  font-size: 17px;
  color: #1c2438;
}
.popupContent {
  padding: 0 0 16px 0;
  flex: 1;
  overflow: auto;
  background: #fff;
}
.popupBankName {
  height: 44px;
  font-family: PingFangSC-Regular;
  text-align: left;
  font-size: 14px;
  color: #1c2438;
  padding: 0 16px;
  display: flex;
  align-content: center;
  border-bottom: 1px solid #eee;
  border-top: 1px solid #eee;
}
.popupBankNameLeft {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 20px;
}
.popupBankNameright {
  display: flex;
  justify-content: center;
  align-items: center;
}
.popupBankNum {
  font-family: PingFangSC-Regular;
  text-align: left;
  font-size: 18px;
  color: #1c2438;
  padding: 0 16px;
}
.popupFooter_Button {
  width: 100%;
}
.cross {
  font-size: 18px;
  color: #80848f;
}
.UnbundCard >>> .van-button__text {
  display: contents;
}

.unbundlBox {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 8px;
}
.unbundl {
  width: 43.5%;
  height: 42px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #ff6538;
  margin-right: 1%;
  border-radius: 3px;
  color: #ff6538;
}
.confirm {
  width: 43.5%;
  height: 44px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 1%;
}
.popupBox {
  height: 100%;
  display: flex;
  flex-direction: column;
}
</style>
